module.exports = __webpack_public_path__ + "static/media/uv_icon.aaf231e7.png";